module.exports = __webpack_public_path__ + "f620f8e0922b7cc4b7c6c28f3d87888b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/masis.png
// module id = 607
// module chunks = 0